#import "./AddressFull.graphql"
#import "./CompanyFull.graphql"
#import "./GoPayDataFull.graphql"
#import "./ImageFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"

fragment InquiryFull on Inquiry {
  billingAddress {
    ...AddressFull
  }
  company {
    ...CompanyFull
  }
  cancelReason
  refundAmount
  cancelEmailIndex
  cancelEmailSent
  cancelledOnlinePayments {
    checked
    goPayData {
      ...GoPayDataFull
    }
    proformaId
    proformaNumber
    proformaUrl
    invoiceId
    invoiceNumber
    invoiceUrl
    correctiveDocumentId
    correctiveDocumentNumber
    correctiveDocumentUrl
  }
  checkFinalPaymentsIndex
  customCakeDetail {
    celebrantAge
    celebrantName
    deliveryType
    figurine
    filling
    images {
      ...ImageFull
    }
    size
    shippingAddress {
      ...AddressFull
    }
    theme
  }
  date
  deliveryTime
  email
  fullName
  gdprApprovedAt
  id
  inventoryLoan {
    goPayData {
      ...GoPayDataFull
    }
    itemDescription
    paymentType
    rentalFee
    securityDeposit
    status
    taxLevel
    # Invoices
    proformaId
    proformaNumber
    proformaUrl
    invoiceId
    invoiceNumber
    invoiceUrl
    correctiveDocumentId
    correctiveDocumentNumber
    correctiveDocumentUrl
  }
  inventoryLoanRefundAmount
  invoices {
    advanceProformaId
    advanceProformaNumber
    advanceProformaUrl
    advanceInvoiceId
    advanceInvoiceNumber
    advanceInvoiceUrl
    advanceCorrectiveDocumentId
    advanceCorrectiveDocumentNumber
    advanceCorrectiveDocumentUrl
    finalProformaId
    finalProformaNumber
    finalProformaUrl
    finalInvoiceId
    finalInvoiceNumber
    finalInvoiceUrl
    finalCorrectiveDocumentId
    finalCorrectiveDocumentNumber
    finalCorrectiveDocumentUrl
    subjectId
  }
  inquiryReminderSent
  note
  noteForVyrobna
  orderId
  orderSpecification
  payment {
    advancePaymentAmount
    advancePaymentType
    advanceGoPayData {
      ...GoPayDataFull
    }
    advanceDue
    finalPaymentAmount
    finalPaymentType
    finalGoPayData {
      ...GoPayDataFull
    }
    finalInvoiceItems {
      description
      price
    }
    finalDue
    status
    taxLevel
    totalPrice
  }
  phoneNumber
  status
  summaryEmailIndex
  tenantId
  type
  weddingDetail {
    cuttingTime
    decorationStyle
    deliveryDate
    deliveryType
    estimatedGuests
    fillingTasteTest
    images {
      ...ImageFull
    }
    size
    status
    weddingAddressNote
    weddingAddress {
      ...AddressFull
    }
    weddingLocation
    layerFillings {
      description
      id
      layer
    }
  }
  internalTask {
    description
    dueDate
    completed
  }
  datePaginationGroup
  deliveryTimeIntervalDuration {
    hours
    minutes
  }
  transportStartTime
  placeOfProduction
  relatedOrderNumber
  transfereeName
  transfereePhone
  ...TimestampsFull
  ...SearchIndexFull
}
